<div class="edge-footer">
    <div class="edge-container">
        <dui-copyright></dui-copyright>
        <div class="edge-nav">
            <a [href]="commonUrls.databank.privacyPolicy" class="edge-nav-link">Privacy Policy</a>
            <a [href]="commonUrls.databank.termOfUse" class="edge-nav-link">Terms of Use</a>
        </div>
    </div>
</div>
